import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import boardCompanyService from './board-company.service';

export interface BoardCompanyState { }

const BoardCompanyStore: Module<BoardCompanyState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async post(context, { board_id, company_id, sequence }: { board_id: number; company_id: number; sequence: number }) {
         const BODY = { board_id, company_id, sequence };
         return await boardCompanyService.post(BODY).then((response) => {
            return response;
         });
      },
      async delete(context, { board_company_id }: { board_company_id: number }) {
         return await boardCompanyService.delete(board_company_id);
      },
      async patch(context, { board_company_id, path, value }: { board_company_id: number; path: string; value: boolean }) {
         const BODY = [
            {
               op: 'replace',
               path,
               value,
            },
         ];

         await boardCompanyService.patch(board_company_id, BODY);
      },
   },
};

export default BoardCompanyStore;
